const insertSpaces = (text: string, repeat: number) => {
  return text.replace(new RegExp(`(.{${repeat}})`, 'g'), '$1 ');
};

export function accountNumberWithSpaces(accountNumber: string) {
  if (accountNumber.length !== 26) return accountNumber;

  return insertSpaces(accountNumber.slice(0, 2), 2) + insertSpaces(accountNumber.slice(2), 4).trim();
}
